import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { I18n } from 'react-redux-i18n';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import DropDown from '../../../common/dropdown/DropDown';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import { isNotLogin, syncComponentSelector } from '../../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import SearchBox from '../common/SearchBox';
import './index.scss';
import {
  changeAlertGroup,
  changeCurrentHistorySearch,
  fetchAlertHistory,
  loadMoreAlertHistory,
  REDUCER_NAME,
} from '../reducer';
import Const from './Const';
import AlertHistoryTable from './Table';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { REDUCER_NAME as ALERT_REDUCER } from '../../../main-layout/header/right/alerts/reducer';

const defaultCurrentSearch = {};

class AlertHistory extends PureComponent {
  state = {
    currentPage: 1,
    currentSearch: defaultCurrentSearch,
    resetScrollIndex: 1,
    localeIndex: 1,
  };

  componentDidMount() {
    this.getAlertHistory();
    EventEmitter.subscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { resetScrollIndex } = this.state;
    const { alertGroup } = this.props;
    if (alertGroup !== nextProps.alertGroup) {
      this.setState({
        currentPage: 1,
        resetScrollIndex: resetScrollIndex + 1,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { alertGroup } = this.props;
    if (alertGroup !== prevProps.alertGroup) {
      this.getAlertHistory();
    }
    const { isLoadingOrganization } = this.props;
    if (
      isLoadingOrganization !== prevProps.isLoadingOrganization &&
      !isLoadingOrganization
    ) {
      setTimeout(() => {
        this.setState({
          localeIndex: this.state.localeIndex + 1,
        });
      }, 0);
    }
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe(SYNC_COMPONENT_SEARCH, this.onSyncSearch);
  }

  onSyncSearch = data => {
    const { syncType, componentId } = this.props;
    const isSameComponent =
      componentId === data.componentId && data.componentId;
    if (
      syncType === TYPE_DISABLE ||
      data.syncType !== syncType ||
      isSameComponent
    ) {
      return;
    }
    this.onSearchChange(data.search);
  };

  getAlertHistory = () => {
    const { fetchAlertHistory } = this.props;

    fetchAlertHistory(this.getParams());
  };

  getParams = () => {
    const { currentSearch, currentPage } = this.state;
    const { alertGroup } = this.props;
    return {
      OrganCode: currentSearch.organCode || '',
      Page: currentPage,
      PageSize: Const.maxRowData,
      AlertCode: (Const.mapGroupCodes[alertGroup] || []).join(','),
    };
  };

  getDataFromRedux = state => state[REDUCER_NAME].alertHistoryById;

  handleScroll = e => {
    const { alertHistoryIds } = this.props;
    if (alertHistoryIds.length < Const.maxRowData) return;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (bottom) {
      this.loadMoreActive();
    }
  };

  loadMoreActive = () => {
    const { currentPage } = this.state;
    const { totalAlertHistory, loadMoreAlertHistory } = this.props;
    if (Math.ceil(totalAlertHistory / Const.maxRowData) > currentPage) {
      this.setState(
        {
          currentPage: currentPage + 1,
        },
        () => loadMoreAlertHistory(this.getParams()),
      );
    }
  };

  onSearchChange = currentSearch => {
    const { changeCurrentHistorySearch } = this.props;
    changeCurrentHistorySearch(currentSearch);
    this.setState(
      {
        currentSearch: currentSearch || defaultCurrentSearch,
        currentPage: 1,
      },
      () => {
        this.getAlertHistory();
        this.setState({
          resetScrollIndex: this.state.resetScrollIndex + 1,
        });
      },
    );
  };

  getAlertGroups = () => {
    const { user } = this.props;
    if (isNotLogin(user)) {
      return Const.alertGroups.filter(item => item !== 'PersonalAlert');
    }
    return Const.alertGroups;
  };

  render() {
    const { currentSearch, resetScrollIndex, localeIndex } = this.state;

    const {
      showSetting,
      isShowSetting,
      alertGroup,
      changeAlertGroup,
    } = this.props;

    return (
      <div className="tab-content d-flex flex-fill flex-column h-auto alert-history">
        <div className="d-flex w-100 ml-0 mb-10 mr-0 justify-content-between align-items-center flex-shrink-0">
          <div className="d-flex align-items-center">
            <SearchBox
              onChange={this.onSearchChange}
              currentSearch={currentSearch}
            />

            <div className="list-filter alert-code-dropdown">
              <div className="line-drop">
                <DropDown
                  isI18n
                  currentKey={alertGroup}
                  listKey={this.getAlertGroups()}
                  listDataByKey={Const.alertGroupDropDownData}
                  change={changeAlertGroup}
                />
              </div>
            </div>
          </div>
        </div>
        <AlertHistoryTable
          key={localeIndex}
          resetScrollIndex={resetScrollIndex}
          handleScroll={this.handleScroll}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  totalAlertHistory: state[REDUCER_NAME].totalAlertHistory,
  alertHistoryIds: state[REDUCER_NAME].alertHistoryIds,
  alertGroup: state[REDUCER_NAME].alertGroup,
  locale: state.i18n.locale,
  isLoadingOrganization: state[COMMON_REDUCER_NAME].isLoadingOrganization,
  syncType: syncComponentSelector(state, componentName, componentId),
  systemAlert: state[ALERT_REDUCER].systemAlert,
  user: state.userInfo,
});

const mapDispatchToProps = {
  fetchAlertHistory,
  loadMoreAlertHistory,
  changeCurrentHistorySearch,
  changeAlertGroup,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AlertHistory);
